/**
 * MSK Visualisation Reducers
 */
 import {
    MSKVISUAL_ACTION, 
    ALL_MSKVISUAL,
    FETCH_MSKYEAR,
    MSK_VISUALISATION_DETAILS,
    MSK_CREATE_VISUALISATION,
    MSK_VISUALISATION_DELETE,
    ALL_MSKSTUDENT
 } from 'Actions/types';

/**
 * initial auth user
 */
const INIT_STATE = {
    mskvisualisationlist:[],
    mskyears:[],
    visualisationdetails:[],
    mskstudentlist:[],
    loading: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        
        case MSKVISUAL_ACTION:
            return { ...state, loading: true };

        case ALL_MSKVISUAL:
            return { ...state, loading: false, mskvisualisationlist: action.payload };
        
        case FETCH_MSKYEAR:
            return { ...state, loading: false, mskyears: action.payload};

        case MSK_VISUALISATION_DETAILS:
            return { ...state, loading: false, visualisationdetails: action.payload};  
            
        case MSK_CREATE_VISUALISATION:
            return { ...state, loading: false};  
        
        case MSK_VISUALISATION_DELETE:
            return { ...state, loading: false};   
            
        case ALL_MSKSTUDENT:
            return { ...state, loading: false, mskstudentlist: action.payload};      

        default: return { ...state };
    }
}